import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraOverlayDrawer } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { EntityForm } from './EntityForm';
/**
 * Create/edit records in a side drawer (SpecraOverlayDrawer shell) hosting the
 * shared declarative form body (EntityForm). The same EntityForm also powers
 * edit-in-place inside the detail drawer, so the create-drawer and the inline
 * editor render identical fields/validation/footer.
 */ export function EntityFormDialog({ open, onOpenChange, title, description, fields, defaultValues, onSubmit, isSubmitting, submitLabel = 'Save', topContent, extraContent, readOnly }) {
    return /*#__PURE__*/ _jsx(SpecraOverlayDrawer, {
        open: open,
        onOpenChange: (next)=>{
            // Every dismissal path — Escape, overlay click, the X — funnels through
            // here. While a save is in flight none may abandon it: the mutation
            // would resolve against a drawer the user believes cancelled (phantom
            // navigation, or a duplicate create when they retry). Footer buttons are
            // already disabled; this closes the other three exits.
            if (!next && isSubmitting) return;
            onOpenChange(next);
        },
        title: title,
        description: description,
        testId: Testids.deliveryShared.formDialog,
        // EntityForm owns the scroll split: fields scroll, the footer inside the
        // same <form> stays pinned so submit is always reachable. scrollBody=false
        // + a flex-column body lets the inner form take over the height split.
        scrollBody: false,
        bodyProps: {
            className: 'flex flex-col'
        },
        children: /*#__PURE__*/ _jsx(EntityForm, {
            active: open,
            fields: fields,
            defaultValues: defaultValues,
            onSubmit: onSubmit,
            onCancel: ()=>onOpenChange(false),
            isSubmitting: isSubmitting,
            submitLabel: submitLabel,
            topContent: topContent,
            extraContent: extraContent,
            readOnly: readOnly
        })
    });
}
